/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Input_LabelInputs */

const en_csv_input_label = /** @type {(inputs: Csv_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV Input`)
};

const ko_csv_input_label = /** @type {(inputs: Csv_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 입력`)
};

const ja_csv_input_label = /** @type {(inputs: Csv_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV入力`)
};

/**
* | output |
* | --- |
* | "CSV Input" |
*
* @param {Csv_Input_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_input_label = /** @type {((inputs?: Csv_Input_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Input_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_input_label(inputs)
	if (locale === "ko") return ko_csv_input_label(inputs)
	return ja_csv_input_label(inputs)
});